import { Container, Grid } from "@eworkit/iris";
import React, { FC } from "react";

import { InfiniteResultState } from "@/core/queries/useInfiniteQuery";
import { JobRequestListDto } from "@/data/job-requests/types/JobRequest";

import { DashboardJobsGridItem } from "./DashboardJobsGridItem";

interface DashboardJobsGridProps {
  query: InfiniteResultState<JobRequestListDto, unknown>;
}

export const DashboardJobsGrid: FC<DashboardJobsGridProps> = ({ query: { data } }) => {
  return (
    <Container>
      <Grid columns={["repeat(2, 1fr)", null, null, "repeat(4, 1fr)"]} gap={["xs", null, null, "sm"]}>
        {data?.pages.map(page => page.content.map(item => <DashboardJobsGridItem key={item.id} item={item} />))}
      </Grid>
    </Container>
  );
};
